import { SVGProps } from 'react';

const MaskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM3.75 12a8.25 8.25 0 0 1 14.081-5.831L6.17 17.83A8.227 8.227 0 0 1 3.75 12Z" />
  </svg>
);

export default MaskIcon;
